'use client';

import Photo from '@components/elements/Photo';
import { trackEvent } from '../../../lib/analytics/posthog';
import { EVENTS } from '../../../lib/analytics/events';
import { getSeoPrice } from '@utils/seo-locale';
import { formatPrice } from '@utils/price';
import { formatDuration } from '@lib/duration';
import { isDefaultImage } from '@lib/photo';
import { vendorStorefrontUrl } from '@utils/storefront-url';

/**
 * Lista de precios, como la pizarra de una peluquería: servicio, puntos guía, duración y precio.
 * Cada fila lleva a reservar ese servicio en la página del negocio en agora.red.
 */
export default function PriceList({ vendor, campaign = 'vendor_profile' }) {
  const isRealVendor = !vendor.is_created_by_marketplace;
  const services = (vendor.services || []).filter((s) => !s.status || String(s.status).toLowerCase() === 'active');
  if (!services.length) return null;

  return (
    <section className="pf-sec" aria-labelledby="precios">
      <h2 id="precios" className="pf-h2 font-display">
        Lista de precios
      </h2>
      <div className="plist">
        {services.map((service, index) => {
          const href = isRealVendor
            ? vendorStorefrontUrl(vendor.username, { serviceSlug: service.slug, campaign, content: 'price_list' })
            : `/negocios/${vendor.username}/servicios/${service.slug}`;
          const { currency, price } = getSeoPrice(service, vendor.country);
          const showPrice = !service.is_price_hidden && Number(price) > 0;
          const showDuration = !service.is_duration_hidden && Number(service.duration) > 0;
          const hasPhoto = service.cover_url && !isDefaultImage(service.cover_url);
          return (
            <a
              key={service.id}
              href={href}
              className="plist__row"
              onClick={() =>
                trackEvent(EVENTS.VENDOR_SERVICE_CLICKED, {
                  vendor_username: vendor.username,
                  service_name: service.name,
                  position: index
                })
              }
            >
              {hasPhoto ? (
                <Photo src={service.cover_url} size={250} alt="" className="plist__thumb" />
              ) : (
                <span className="plist__thumb plist__thumb--empty" aria-hidden="true" />
              )}
              <span className="plist__main">
                <span className="plist__line">
                  <span className="plist__name">{service.name}</span>
                  <span className="plist__dots" aria-hidden="true" />
                  {showDuration && <span className="plist__dur">{formatDuration(service.duration)}</span>}
                  {showPrice && <span className="plist__price">{formatPrice(price, currency)}</span>}
                </span>
              </span>
              <span className="plist__cta">{isRealVendor ? 'Reservar' : 'Ver'}</span>
            </a>
          );
        })}
      </div>
    </section>
  );
}
